import Model from './Model'

export default class Category extends Model {

	/** @type number */ id
	/** @type string */ display_name
	/** @type string */ description
	/** @type boolean */ is_shown
	/** @type string */ tag

}
